import { render, staticRenderFns } from "./TemplateManagement.vue?vue&type=template&id=842de7e0&"
import script from "./TemplateManagement.vue?vue&type=script&lang=js&"
export * from "./TemplateManagement.vue?vue&type=script&lang=js&"
import style0 from "./TemplateManagement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports